import React, { ReactElement, FunctionComponent } from 'react'
import BasicText from '../BasicText'
import { HeadlineProps } from '../Headline'

const OnBoardingHeadlineFont: FunctionComponent<HeadlineProps> = ({
    children,
    color,
    textAlign,
    webHeadlineType,
    testID,
}): ReactElement => {
    return (
        <BasicText
            color={color}
            fontSize="FS28"
            lineHeight="LH30"
            textAlign={textAlign}
            webHeadlineType={webHeadlineType}
            testID={testID}
            bold
        >
            {children}
        </BasicText>
    )
}

export default OnBoardingHeadlineFont
